<mat-card-subtitle style="margin-top: 16px;">
  {{containerDesc}}
</mat-card-subtitle>

<form class="dynamic-form" [formGroup]="form" style="width: 100%">
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxFlexFill fxLayoutGap="16px grid">

    <mat-form-field fxFlex="30" width="100%">
      <mat-label>Amount Tendered</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountTendered" autocomplete="new-password"
        (keyup)="amountTenderedChanged()" (focusout)="amountTenderedFocusOut()">
    </mat-form-field>

    <mat-form-field fxFlex="40" width="100%">
      <mat-label>Minus Outstanding</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountOutstanding">
    </mat-form-field>

    <mat-form-field fxFlex="30" width="100%">
      <mat-label>Equals Unpaid</mat-label>
      <input matInput style="text-align: right;" type="number" formControlName="amountDifference">
    </mat-form-field>

    <mat-form-field fxFlex="100" width="100%">
      <mat-label>Pay Just Now Reference</mat-label>
      <input matInput style="text-align: left;" type="text" minlength="0" maxlength="20" formControlName="reference" autocomplete="new-password">
    </mat-form-field>

  </div>
</form>
